import { MDSIconColor } from "./icon.types";
import { Theme } from "@emotion/react";
import styled from "@emotion/styled";

export const StyledIconWrapper = styled.div<{
  $boxSize: number;
  $iconSize: number;
  $color: MDSIconColor;
  $overrideColor?: string;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: ${({ $boxSize }) => $boxSize}px;
  width: ${({ $boxSize }) => $boxSize}px;

  .mds-icon {
    font-size: ${({ $iconSize }) => $iconSize}px;
    height: ${({ $iconSize }) => $iconSize}px;
    width: ${({ $iconSize }) => $iconSize}px;
    color: ${({ $color, $overrideColor, theme }) =>
      getIconColor({ $color, $overrideColor, theme })};
    line-height: 1;
    user-select: none;
    draggable: false;
  }
`;

const getIconColor = ({
  $color,
  $overrideColor,
  theme,
}: {
  $color: MDSIconColor;
  $overrideColor?: string;
  theme: Theme;
}) => {
  if ($overrideColor) return $overrideColor;
  switch ($color) {
    case MDSIconColor.Primary:
      return theme.colors.icon.primary;
    case MDSIconColor.Secondary:
      return theme.colors.icon.secondary;
    case MDSIconColor.Placeholder:
      return theme.colors.icon.placeholder;
    case MDSIconColor.Brand:
      return theme.colors.icon.brand;
    case MDSIconColor.OnAccent:
      return theme.colors.icon.onAccent;
    case MDSIconColor.Selected:
      return theme.colors.icon.selected;
    case MDSIconColor.Emphasis:
      return theme.colors.icon.emphasis;
    case MDSIconColor.Danger:
      return theme.colors.icon.danger;
    case MDSIconColor.Positive:
      return theme.colors.icon.positive;
    case MDSIconColor.OnChromeInactive:
      return theme.colors.icon.onChromeInactive;
    case MDSIconColor.Inherit:
      return "inherit";
    default:
      return theme.colors.icon.primary;
  }
};
